var map = {
	"./audio/click.mp3": 72126,
	"./audio/reaction.mp3": 16275,
	"./audio/select.mp3": 62582,
	"./audio/spin.mp3": 60366,
	"./audio/stick.mp3": 70646,
	"./audio/success.mp3": 16251,
	"./audio/super_success.mp3": 47211,
	"./bitmap_fonts/avenir_white.png": 41498,
	"./bitmap_fonts/avenir_white.xml": 84146,
	"./bitmap_fonts/digital_red.png": 92845,
	"./bitmap_fonts/digital_red.xml": 5833,
	"./bitmap_fonts/panton_green.png": 18533,
	"./bitmap_fonts/panton_green.xml": 52677,
	"./bitmap_fonts/panton_white_extrabold.png": 37457,
	"./bitmap_fonts/panton_white_extrabold.xml": 47505,
	"./fonts/panton/panton-extrabold-webfont.ttf": 97111,
	"./fonts/panton/panton-extrabold-webfont.woff": 81669,
	"./fonts/panton/panton-extrabold-webfont.woff2": 2365,
	"./fonts/phosphate.ttf": 81960,
	"./fonts/phosphate.woff": 55304,
	"./fonts/phosphate.woff2": 90362,
	"./images/bg_reel_tile.png": 18542,
	"./images/blue_particle.png": 30132,
	"./images/chain2.png": 3978,
	"./images/crank_piece.png": 57883,
	"./images/jackpot.png": 45415,
	"./images/lock.png": 4328,
	"./images/reel.png": 14861,
	"./images/shadow.png": 48081,
	"./images/star_particle.png": 33276,
	"./images/starting_soon.png": 4495,
	"./images/victory.png": 33179,
	"./images/victory_back.png": 93901,
	"./images/victory_back_mobile.png": 42104,
	"./images/victory_coins.png": 65098,
	"./images/victory_coins_mobile.png": 17347,
	"./spritesheets/assets.json": 82579,
	"./spritesheets/assets.png": 43957,
	"./spritesheets/chain.json": 97315,
	"./spritesheets/chain.png": 51411,
	"./spritesheets/coins.json": 73348,
	"./spritesheets/coins.png": 63686,
	"./spritesheets/crank.json": 91081,
	"./spritesheets/crank.png": 4561,
	"./spritesheets/light.json": 91617,
	"./spritesheets/light.png": 56996,
	"./spritesheets/numbers.json": 65608,
	"./spritesheets/numbers.png": 32058,
	"./spritesheets/particle.json": 87440,
	"./spritesheets/particle.png": 26492,
	"./spritesheets/play_btn.json": 10559,
	"./spritesheets/play_btn.png": 55321,
	"./spritesheets/red_button.json": 26770,
	"./spritesheets/red_button.png": 63062,
	"./spritesheets/splitters.json": 84114,
	"./spritesheets/splitters.png": 40508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39663;